import { render } from "./CustomizationBuildSummaryBody.vue?vue&type=template&id=279e32e0&scoped=true"
import script from "./CustomizationBuildSummaryBody.vue?vue&type=script&lang=js"
export * from "./CustomizationBuildSummaryBody.vue?vue&type=script&lang=js"

import "./CustomizationBuildSummaryBody.vue?vue&type=style&index=0&id=279e32e0&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-279e32e0"]])

export default __exports__